// extracted by mini-css-extract-plugin
export var base = "_2j-0";
export var updateBanner = "_2j-1";